import { render, staticRenderFns } from "./EstablishmentHome.vue?vue&type=template&id=29fb39f6&scoped=true&lang=pug&"
import script from "./EstablishmentHome.vue?vue&type=script&lang=coffee&"
export * from "./EstablishmentHome.vue?vue&type=script&lang=coffee&"
import style0 from "./EstablishmentHome.vue?vue&type=style&index=0&id=29fb39f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29fb39f6",
  null
  
)

component.options.__file = "EstablishmentHome.vue"
export default component.exports